import { a as Ji, P as Ki, g as Mi } from "./popupTip-06ee114c.js";
import "./es.array.map-d821aaf5.js";
import m from "styled-components";
import { Link as l } from "./link.js";
import { jsx as r, jsxs as e } from "react/jsx-runtime";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./export-cdcbfb2b.js";
import "./es.object.assign-7e79fd7b.js";
import "./object-keys-719a5561.js";
import "./web.set-timeout-72b6430f.js";
import "./function-apply-4756dee6.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "@ucl/shared-component-foundations";
import "./index-8b07dec9.js";
import "react";
import "react-dom";
import "./es.object.keys-9d66766f.js";
import "./usePopoverIndex.js";
import "./aria.js";
import "./es.array.filter-4e9c9996.js";
import "./array-iteration-759bfbfa.js";
import "./es.object.to-string-f55666a8.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./classof-21a3574e.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./es.array.concat-d1c9b847.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./array-method-is-strict-e5a3c878.js";
import "./getMetrics-953aa4f8.js";
import "./useEventListener.js";
import "./getTarget-19e0f923.js";
import "./isClient-2f5bedbd.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./useWindowSize.js";
import "./button.js";
import "./combineRefs-c9ad2c39.js";
import "./index-5d0f31c6.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.from-fe752fa6.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./iconButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.parse-int-d7709701.js";
import "./string-trim-14e37ad3.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./string-html-forced-a746405b.js";
var u = /* @__PURE__ */ m.div.withConfig({
  displayName: "popupTipLinksContainer__LinksWrapper",
  componentId: "sc-8h04mk-0"
})(["position:", ";display:", ";padding:", ";"], function(p) {
  var i;
  return p == null || (i = p.theme) == null || (i = i.components) == null || (i = i.popupTip) == null || (i = i.LinksWrapper) == null ? void 0 : i.position;
}, function(p) {
  var i;
  return p == null || (i = p.theme) == null || (i = i.components) == null || (i = i.popupTip) == null || (i = i.LinksWrapper) == null ? void 0 : i.display;
}, function(p) {
  var i;
  return p == null || (i = p.theme) == null || (i = i.components) == null || (i = i.popupTip) == null || (i = i.LinksWrapper) == null ? void 0 : i.padding;
}), a = /* @__PURE__ */ m.span.withConfig({
  displayName: "popupTipLinksContainer__Divider",
  componentId: "sc-8h04mk-1"
})(["margin:", ";color:", ";"], function(p) {
  var i;
  return p == null || (i = p.theme) == null || (i = i.components) == null || (i = i.popupTip) == null || (i = i.DividerLink) == null ? void 0 : i.margin;
}, function(p) {
  var i;
  return p == null || (i = p.theme) == null || (i = i.components) == null || (i = i.popupTip) == null || (i = i.DividerLink) == null ? void 0 : i.color;
}), Fi = function(i) {
  var t = i.links;
  return /* @__PURE__ */ r(u, {
    children: t.map(function(o, n) {
      return /* @__PURE__ */ e("div", {
        children: [/* @__PURE__ */ r(l, {
          to: o.url,
          target: "_blank",
          rel: "noopener noreferrer",
          children: o.title
        }), n !== t.length - 1 && /* @__PURE__ */ r(a, {
          children: " | "
        })]
      }, o.id);
    })
  });
};
export {
  Ji as PopupPlacement,
  Ki as PopupTip,
  Fi as PopupTipLinks,
  Mi as getPosition
};
